import { FirebaseError } from 'firebase/app';

// Maps Firebase Auth error codes to friendly, user-facing copy.
const messages: Record<string, string> = {
  'auth/invalid-email': 'That email address looks invalid.',
  'auth/user-disabled': 'This account has been disabled. Contact support for help.',
  'auth/user-not-found': 'No account found with that email.',
  'auth/wrong-password': 'Incorrect email or password.',
  'auth/invalid-credential': 'Incorrect email or password.',
  'auth/email-already-in-use': 'An account with this email already exists.',
  'auth/weak-password': 'Please choose a stronger password (at least 6 characters).',
  'auth/missing-password': 'Please enter your password.',
  'auth/too-many-requests': 'Too many attempts. Please wait a moment and try again.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
  'auth/requires-recent-login': 'Please re-authenticate to continue.',
  'auth/expired-action-code': 'This link has expired. Please request a new one.',
  'auth/invalid-action-code': 'This link is invalid or has already been used.',
  'auth/popup-closed-by-user': 'The sign-in window was closed before completing.',
  'auth/operation-not-allowed': 'This sign-in method is not enabled.',
};

/**
 * Normalizes any thrown value into a human-readable message. Use in catch blocks
 * around any Firebase auth call so the UI never shows a raw error code.
 */
export function authErrorMessage(error: unknown): string {
  if (error instanceof FirebaseError) {
    return messages[error.code] ?? 'Something went wrong. Please try again.';
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Please try again.';
}

/** True when the error is Firebase's "you need to sign in again" signal. */
export function isReauthRequired(error: unknown): boolean {
  return error instanceof FirebaseError && error.code === 'auth/requires-recent-login';
}
